import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OperationsAreasBlockData from '../../../Models/Content/OperationsAreasBlockData';
import OperationsAreas from './OperationsAreas';
import './OperationsAreasBlock.scss';

export default class OperationsAreasBlock extends EpiComponent<OperationsAreasBlockData> {
  public render(): ReactNode | ReactNodeArray | null {

    return (
      <div className="operations-areas-block">
        <div className="operations-areas-page-wrapper">
          <OperationsAreas iContent={this.props.data} context={this.getContext()}/>
        </div>
      </div>
    )
  }
}
